import { notifUtils } from "../components/NotifUtils/NotifUtils";
import { handleError } from "../components/Utils/Utils";
import NewsletterService from "../Services/NewsletterService/NewsletterService";

export const getList = (store, value, prevTabActive) => {
  const isLoading = !store.state.isLoading;
  const status = 200;
  store.setState({ isLoading, status });
  NewsletterService.getData(value)
    .then((response) => {
      let data = response.data;
      // console.log(data);
      const isLoading = false;
      const status = data.message;
      store.state.data = data;
      // console.log("_______");
      // console.log(store.state.data);
      // console.log("+++++=");
      store.setState({
        isLoading,
        header: response.headers,
        status,
      });
    })
    .catch((error) => {
      handleError(error);
    });
};
